import { useState, useEffect } from "react";
import Header from "modules/SubComponents/Header";

import { getCompetitionImg, getStoreImg, getVideoPath } from "Network";
import Uploader from "./components/Uploader";
import VideoUploader from "./components/VideoUploader";

export default function TVMedia() {
  const [competitionImagePath, setCompetitionImagePath] = useState("");
  const [storeImagePath, setStoreImagePath] = useState("");
  const [videoPath, setVideoPath] = useState("");

  // Fetch existing image paths on component mount
  useEffect(() => {
    getCompetitionImg(
      (success) => {
        setCompetitionImagePath(success.data.competitionPath);
      },
      (error) => {
        console.log(error);
      }
    );
    getStoreImg(
      (success) => {
        setStoreImagePath(success.data.storePath);
      },
      (error) => {
        console.log(error);
      }
    );

    getVideoPath(
      (success) => {
        setVideoPath(success.data.introductionVideoPath);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  return (
    <div className="tv-photos">
      <Header title="TV Media" />
      <Uploader
        title="Competition"
        imgPath={competitionImagePath}
        setImgPath={setCompetitionImagePath}
        keyName="competitionPath"
        api="api/competition/editImage"
      />
      <Uploader
        title="Store"
        imgPath={storeImagePath}
        setImgPath={setStoreImagePath}
        keyName="storePath"
        api="api/store/editImage"
      />
      <VideoUploader title={"Intro video"} videoPath={videoPath} />
    </div>
  );
}
